module.exports = __webpack_public_path__ + "static/media/t20.914df544.jpg";